// https://vuex.vuejs.org/en/state.html

export default {
    user: null,
    snackbar: {
        snackbarColor: null,
        snackbarText: null,
    },
    anggota: {
        id: null,
        nama: null,
        angkaFavorit: null,
        tanggalLahir: null
    },
    kendaraan: {
        nomorPolisi: null,
        nomorRangka: null,
        nomorMesin: null,
        cc: null,
        warnaKendaraan: null,
        warnaPlat: null,
        fungsiKendaraan: null,
        posisiSetir: null,
        jumlahPintu: null,
        radio: null,
        hp: null,
        keterangan: null,
        noBpkb: null,
        noStnk: null,
        noBlankoStnk: null,
        jumlahSumbu: null,
        jumlahGandengan: null,
        jumlahRoda: null,
        njkb: null,
        masaPajak: null,
        masaStnk: null,
        sumber: null,
        idRiwayatRanmor:null,
    },
    deskripsiKendaraan: {
        cariKendaraaanByNomorRangkaDialog: false,
        cariKodeJenisDialog: false,
        merk: null,
        tipe: null,
        tahunBuat: null,
        bahanBakar: null,
        kelompok: null,
        kategori: null,
        kodeJenis: null,
        kodeMerekTipe: null,
        kodeBahanBakar: null,
        idTipeKendaraan: null,
        jenis: null,
        status: null,
        tahunNulaiJual: null
    },
    identitas: {
        cariIdentitasDialog: false,
        nik: null,
        nama: null,
        alamat: null,
        rt: null,
        rw: null,
        kotamadya: null,
        kecamatan: null,
        kelurahan: null,
        kodePos: null,
        noKK: null,
    },
    namaWP: {
        cariNamaDialog: false,
    },
    syarat: {
        jenisTransaksi: null,
        nomorIdentitasKuasa: null,
        namaKuasa: null
    },
    dokumenSyarat: [],
    wajibPajak: {
        jenisIdentitas: null,
        nomorIdentitas: null,
        nomorKK: null,
        nama: null,
        tanggalLahir: null,
        alamat: null,
        propinsi: null,
        kotamadya: null,
        kecamatan: null,
        kelurahan: null,
        kodePos: null,
        kodeBadanHukum: null,
        email: null,
        noTelepon: null,
        rt: null,
        rw: null,
        kendaraanKe: null,
        asalData: null,
        namaKelurahan: null,
    },
    jenisTransaksi: {
        jenisTransaksi: null,
        flowTransaksi: null
    },
    errorLogin: {
      pesan: ''
    },
    tujuanMutasi: {
        idTujuanMutasi: null,
        tujuanMutasiDialog: false,
        namaTujuanMutasi: null,
        alamatTujuanMutasi: null
    },
    accessTime: null,
    listWarnaKendaraan : null
}
